import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import axios from 'axios'
import VueMoment from 'vue-moment'

Vue.use(VueMoment)
Vue.use(BootstrapVue)

Vue.config.productionTip = false
Vue.prototype.$http = axios
// axios.defaults.baseURL = 'http://localhost:3000/'
// axios.defaults.baseURL = 'http://223.130.77.30/'

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
